import * as PropTypes from 'prop-types';
import * as React from 'react';
import { AccordionContext } from './AccordionContext.js';

/**
 * Accordion
 * @param props
 * @description
 * wrapper componet that keep track of 'expandedContentId'
 * it provide context for child components to update expandedContentId
 * Close follow this aria example
 * https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
 */
var Accordion = props => {
  var {
    children,
    className,
    collapseAll,
    expandedContentId,
    isAccordion
  } = props;
  var [currentExpandedContentId, setCurrentExpandedContentId] = React.useState(expandedContentId || '');
  React.useEffect(() => {
    if (isAccordion) {
      setCurrentExpandedContentId(expandedContentId || '');
    }
  }, [expandedContentId, isAccordion]);

  /*  eslint-disable react/jsx-no-constructed-context-values */
  var contextValue = {
    collapseAll,
    expandedContentId: currentExpandedContentId,
    isAccordion,
    setExpandedContentId: setCurrentExpandedContentId
  };
  var classnames = "accordion ".concat(className).trim();
  var hcid = "".concat(Accordion.name.toLocaleLowerCase(), "-").concat("10.6.2");
  return /*#__PURE__*/React.createElement("div", {
    className: classnames,
    "data-hcid": hcid
  }, /*#__PURE__*/React.createElement(AccordionContext.Provider, {
    value: contextValue
  }, children));
};
Accordion.propTypes = {
  className: PropTypes.string,
  collapseAll: PropTypes.bool,
  expandedContentId: PropTypes.string,
  isAccordion: PropTypes.bool
};
Accordion.defaultProps = {
  className: '',
  collapseAll: false,
  expandedContentId: '',
  isAccordion: true
};

export { Accordion };
